module.exports = __webpack_public_path__ + "img/Youtube.f71e952d.png";